module.exports = __webpack_public_path__ + "img/env_8.c1038d6e.jpg";